"use strict";
function FilteredQuery(filtered) {
    return { filtered: filtered };
}
exports.FilteredQuery = FilteredQuery;
//# sourceMappingURL=FilteredQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/query/query_dsl/compound/FilteredQuery.js
// module id = 441
// module chunks = 0